// @flow
import React from 'react';
import { DateUtil } from 'utils/DateUtil';
import SortOverlayDropdown from 'components/atoms/sortOverlayDropdown';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  data: Object<MetaDescription>,
};

type MetaDescription = {
  title: string,
  description: string,
  venue_name: string,
  location: string,
  event_time: Object,
};

const TicketMetaDescription = (props: Props) => {
  const {
    data,
    value,
    placeholder,
    onSelect,
    showCart,
    showFnB,
    extractDates,
    resetTableCapacity,
  } = props;
  const renderTime = () => {
    return DateUtil.getEventDetailBannerDate(
      data.event_time?.concert_date,
      data.event_time?.start_time
    );
  };
  return (
    <div className={'ticket-meta-details'}>
      <h1 className={'event-name'}>{data.title} </h1>
      <p className={'event-description'}>
        Select a desired area of the venue on the map below to proceed with the
        ticket purchase
      </p>
      <h3 className={`${showFnB ? 'outlet-fnb' : 'outlet-name'}`}>
        Venue: {data.venue_name}, {data.location}
      </h3>
      {showCart || showFnB ? (
        <h3 className={'event-time'}>{renderTime()}</h3>
      ) : (
        <div className={'dates-dropdown'}>
          <SortOverlayDropdown
            options={extractDates}
            onSelect={option => (onSelect(option), resetTableCapacity())}
            value={value}
            placeholder={placeholder}
            mode={'transparent'}
            className={'date-select-dropdown'}
          />
        </div>
      )}
    </div>
  );
};

export default TicketMetaDescription;
